import { useState } from "react";
import { CategoriesData, MeterCategories } from "../types";
import { orderedMeterCategories } from "../utils";
import { MeterBar } from "./MeterBar";

interface MeterBarsProps {
  categoriesData?: CategoriesData;
  numResultsAnalyzed: number;
  isLoading: boolean;
  hasMeterFailed: boolean;
}

export const MeterBars = ({
  categoriesData,
  numResultsAnalyzed,
  isLoading,
  hasMeterFailed,
}: MeterBarsProps) => {
  const [categoriesTooltipShown, setCategoriesTooltipShown] = useState<
    Record<MeterCategories, boolean | undefined>
  >({ yes: false, no: false, possibly: false, mixed: false });

  const handleCategoryTooltipShownChange = (
    category: MeterCategories,
    isTooltipShown: boolean
  ) => {
    setCategoriesTooltipShown((prev) => ({
      ...prev,
      [category]: isTooltipShown,
    }));
  };

  const shownTooltips = Object.keys(categoriesTooltipShown).filter(
    (category) => categoriesTooltipShown[category as MeterCategories]
  );

  return (
    <div className="flex w-full gap-1 rounded-sm h-5">
      {orderedMeterCategories.map((category) => (
        <MeterBar
          key={category}
          category={category}
          categoryData={categoriesData?.[category] ?? null}
          numResultsAnalyzed={numResultsAnalyzed}
          isLoading={isLoading}
          hasMeterFailed={hasMeterFailed}
          onTooltipShown={() =>
            handleCategoryTooltipShownChange(category, true)
          }
          onTooltipHidden={() =>
            handleCategoryTooltipShownChange(category, false)
          }
          faded={shownTooltips.length > 0 && !categoriesTooltipShown[category]}
        />
      ))}
    </div>
  );
};
